import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import "./OTPVerify.css";

const USERS_BASE_URL = import.meta.env.VITE_USERS_BASE_URL;

function OTPVerify() {
  const [otp, setOtp] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  const email = location.state?.email;
  const purpose = location.state?.purpose || "registration";

  useEffect(() => {
    if (purpose === "password_reset" && email) {
      fetch(`${USERS_BASE_URL}/forgot-password/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          site_name: import.meta.env.VITE_SITE_NAME
        })
        })
        .then(() => console.log("OTP sent for password reset"))
      .catch((err) => alert("Failed to send OTP"));
    }
  }, [email, purpose]);

  const handleVerify = async () => {
    try {
      const response = await fetch(
        `${USERS_BASE_URL}/verify-otp/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
          email,
          otp
          })
        }
      );

      const data = await response.json();

      if (data.message === "Email verified successfully") {
        const { access, refresh } = data.tokens;
        localStorage.setItem("accessToken", access);
        localStorage.setItem("refreshToken", refresh);
        if (purpose === "password_reset") {
          navigate("/reset-password", { state: { email } });
        } else {
          alert("Registration successful!");
          navigate("/login");
        }
      }
    } catch (error) {
      alert("OTP verification failed");
    }
  };

  return (
    <div className="otp-container">
      <div className="otp-box">
        <img src={logo} alt="App Logo" className="logo" />
        <h2>Verify OTP</h2>
        <label className="label">Enter OTP sent to {email}</label>
        <input
          className="input"
          type="text"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          placeholder="Enter OTP"
        />

        <button className="button" onClick={handleVerify}>
          Verify
        </button>
      </div>
    </div>
  );
}

export default OTPVerify;
